enum PlanEntryType {
  RESTRICTED = "RESTRICTED",
  FULL = "FULL",
}

export default PlanEntryType;
